import { useEffect } from 'react';
import { useLocation } from '@reach/router';
import useTracking, { EventType } from '../hooks/useTracking';

const EventTrackingPageView = ({ payload = {} }) => {
  const { trackEvent } = useTracking();
  const { pathname } = useLocation();

  useEffect(() => {
    trackEvent({
      type: EventType.PAGE_VIEW,
      payload: {
        id: pathname,
        ...payload,
        metadata: {
          pathname,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  /* We only want pathname in this array since we only want to track a view event when the path changes.
    If `trackEvent` is also added to the dependencie array we'll get extra page view events as the user is
    logged in behind the scenes and the dependencies for `trackEvent` change inside `useTracking`. */
  return null;
};

export default EventTrackingPageView;
